import {createAction} from 'typesafe-actions';

export const cashierError = createAction('CASHIER_ERROR')<{error: unknown} | void>();
